import ProductTransformer from './ProductTransformer';

export default class ProductOrderSummaryTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteSummary') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    [
      'productName',
      'productDescriptionSummary',
      'providerName',
      'productRequirementsDetails',
      'priceInformation',
      'promotionPriceOverrideText',
      'regularPriceOverrideText',
      'minimumCommitmentPeriodOverrideText',
      'minimumCommitmentPeriodText',
      'beforeOptinInfoText',
      'emailTextProductOrder',
      'linkInfoText',
    ].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
    ['termsOrderLink', 'rescissionOrderLink'].forEach(field => {
      product.hyperlinks[field] = footnotes.parse(product.hyperlinks[field]);
    });
    if (product.textLists.textToBeConfirmedSummary) {
      product.textLists.textToBeConfirmedSummary.forEach((item, index) => {
        product.textLists.textToBeConfirmedSummary[index] = footnotes.parse(product.textLists.textToBeConfirmedSummary[index]);
      });
    }
  }
}
